import { useMutation, useQuery } from "@tanstack/react-query";
import {
  emailPublicReceiptApi,
  getPublicReceiptApi,
} from "../api/publicReceiptApi";

export const useGetPublicReceiptQuery = (hash: string | null) => {
  return useQuery({
    queryKey: ["publicReceipt", hash],
    queryFn: () => getPublicReceiptApi(hash!),
    enabled: !!hash,
    retry: false,
  });
};

export const useEmailPublicReceiptMutation = () => {
  return useMutation({
    mutationFn: ({ hash, email }: { hash: string; email: string }) =>
      emailPublicReceiptApi(hash, email),
  });
};
